import React from 'react';
import { merge } from 'lodash';
import ReactApexChart from 'react-apexcharts';
import BaseOptionChart from './BaseOptionChart';
import { fCurrency } from 'src/utils/formatNumber';
import { Divider, Typography } from '@material-ui/core';

export default function JobCostChartSignwise({ actualSeries = [], expectedSeries = [], actualTotal = 0, expectedTotal = 0 }) {
  const CHART_DATA = [
    { name: 'Actual Cost', data: actualSeries },
    { name: 'Expected', data: expectedSeries }
  ];

  const chartOptions = merge(BaseOptionChart(), {
    colors: ['#507db8', '#e2e3e5'],
    stroke: {
      curve: 'smooth',
      width: [2.5, 2.5],
      dashArray: [0, 6]
    },
    tooltip: {
      y: {
        formatter: (val) => val.toFixed(2)
      }
    },
    xaxis: {
      type: 'category',
      categories: ['', ''],
      labels: { show: false },
      axisTicks: { show: false },
      axisBorder: { show: false }
    },
    yaxis: {
      labels: { show: false },
      axisBorder: {
        show: true,
        color: '#11292e',
      }
    },
    grid: {
      xaxis: { lines: { show: false } },
      yaxis: { lines: { show: true } }
    },
    crosshairs: {
      show: true,
      stroke: {
        color: '#11292e',
        width: 1,
        dashArray: 0,
        opacity: 0.3
      }
    }
  });

  return (
    <div
      style={{
        borderRadius: 12,
        padding: 12,
        width: '100%',
      }}
    >
      <Typography variant='h4'>Job Cost</Typography>

      <ReactApexChart
        type="area"
        series={CHART_DATA}
        options={chartOptions}
        height={320}
        width="100%"
      />

      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          padding: 10,
          backgroundColor: 'rgba(255, 255, 255, 0.05)',
          borderRadius: 4,
        }}
      >
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontWeight: 800, fontSize: 18 }}>{fCurrency(actualTotal)}</div>
          <div style={{ fontSize: 12, color: '#6B7280' }}>Actual</div>
        </div>
        <Divider orientation="vertical" flexItem />
        <div style={{ flex: 1, textAlign: 'center' }}>
          <div style={{ fontWeight: 800, fontSize: 18 }}>{fCurrency(expectedTotal)}</div>
          <div style={{ fontSize: 12, color: '#6B7280' }}>Expected</div>
        </div>
      </div>
    </div>
  );
}
